/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.UploadFiles";
        const DRAGOVER_CLASS = "upload-files-dragover";
        const FORM_ICONS_CLASS = "wpt-form-icons";
        const FORM_ICONS_RIGHT_CLASS = "wpt-form-icons--right";
        const UPLOAD_ICON_CLASS = "wpt-font-file_upload";
        const REMOVE_ICON_CLASS = "wpt-font-icon_DeleteDoc";
        const SUCCESS_ICON_CLASS = "wpt-upload-success-icon";
        const INDICATOR_ICON_CLASS = "wpt-upload-indicator";
        const ERROR_ICON_CLASS = "wpt-upload-error-icon";
        const FILETAG_ATTR = 'data-filetag';
        const ACTION_TEMPLATE = `<span class="${FORM_ICONS_CLASS} ${FORM_ICONS_RIGHT_CLASS}"><span class="${UPLOAD_ICON_CLASS}"></span><span class="${REMOVE_ICON_CLASS}"></span></span>`;
        const REMOVE_TEMPLATE = `<span class="${FORM_ICONS_CLASS} ${FORM_ICONS_RIGHT_CLASS}"><span class="${REMOVE_ICON_CLASS}"></span></span>`;
        class UploadFilesWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("UploadFilesWidgetTypeClass.createInstance()");
                    return new UploadFilesWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("UploadFilesWidgetTypeClass._storeHtml()");
                    UploadFilesWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("UploadFilesWidgetTypeClass::constructor");
                if (UploadFilesWidgetInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/UploadFiles/upload-files.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.UploadFilesWidgetTypeClass = UploadFilesWidgetTypeClass;
        class UploadFilesWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                // Behaviour
                this._counter = 1;
                this._clearRowOnUpload = false;
                this._preventRetryUpload = false;
                this._acceptFilter = null;
                // UI Elements
                this._fileInput = null;
                this._dropTarget = null;
                this._filesTableHolder = null;
                this._uploadButtonDiv = null;
                this._uploadAllButton = null;
                this._browseButton = null;
                // Data
                this._fileList = {};
                this._draggedOver = false;
                this._ignoreNextDragLeave = false;
                this._dataTable = null;
                this._currentTableData = null;
                this._processIcon = null;
                this._completeIcon = null;
                this._errorIcon = null;
                // State
                this._activeFileTag = null;
                this._uploadDocType = null;
                this._uploadKeys = null;
                this._uploadDocDate = null;
                this._awaitingUploadData = false;
                this._awaitTimerId = 0;
                this.presentInstance = () => {
                    this._log.info("UploadFilesWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = UploadFilesWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    // Pick up our UI elements
                    this._fileInput = this._container.querySelector('#uploadFilesFileInput');
                    this._dropTarget = this._container.querySelector('#uploadFilesDropSubwidget');
                    this._draggedOver = false;
                    this._ignoreNextDragLeave = false;
                    this._filesTableHolder = this._container.querySelector('#uploadFilesTableHolder');
                    this._uploadButtonDiv = this._container.querySelector('#uploadFilesUploadButtons');
                    this._uploadAllButton = this._uploadButtonDiv.querySelector('#uploadFilesUploadAll');
                    this._browseButton = this._container.querySelector('#uploadFilesBrowseButton');
                    this._widgets.setTitle(this._config, this._container.querySelector('#uploadFilesWidgetTitle'), 'STR_WPT_SELECT_FILES');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    // Translations
                    this._core.Helper.setElementTranslation(this._container.querySelector('#uploadFilesDropLabel'), 'STR_WPT_DROP_FILES_HERE');
                    this._core.Helper.setElementTranslation(this._uploadAllButton.querySelector('#uploadFilesUploadAllLabel'), 'STR_WPT_UPLOAD_ALL');
                    this._core.Helper.setElementTranslation(this._browseButton.querySelector('#uploadFilesBrowseButtonLabel'), 'STR_WPT_LABEL_BROWSE');
                    // Attach events
                    // TODO: add accept filter
                    this._fileInput.addEventListener('change', this._fileSelected);
                    this._dropTarget.addEventListener('dragenter', this._fileDragEnter);
                    this._dropTarget.addEventListener('dragover', this._fileDraggedOver); // needed to allow proper drop handling
                    this._dropTarget.addEventListener('dragleave', this._fileDragLeave);
                    this._dropTarget.addEventListener('drop', this._fileDropped);
                    this._uploadAllButton.addEventListener('click', this._uploadAllClicked);
                    this._browseButton.addEventListener('click', this._browse);
                    let config = this._config;
                    if (config.hasOwnProperty('PreventRetryUpload') && config.PreventRetryUpload)
                        this._preventRetryUpload = true;
                    if (config.hasOwnProperty('ClearRowOnUpload') && config.ClearRowOnUpload)
                        this._clearRowOnUpload = true;
                    if (config.hasOwnProperty('AcceptFilter') && (config.AcceptFilter))
                        this._acceptFilter = config.AcceptFilter;
                    this._fileInput.accept = this._acceptFilter;
                    let maxHeightString = window.getComputedStyle(this._filesTableHolder).maxHeight;
                    let maxHeight = null;
                    if (maxHeightString != "none") {
                        // expecting max-height set in pixels
                        maxHeight = parseInt(maxHeightString, 10);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using max-height: " + maxHeight);
                        }
                    }
                    this._dataTable = new Widgets.ComponentDataTable(this._core, this._filesTableHolder, this, maxHeight);
                    this._dataTable.present();
                    let processSpan = document.createElement('span');
                    processSpan.classList.add(INDICATOR_ICON_CLASS);
                    this._core.Helper.getWptSpinner(spinner => {
                        processSpan.innerHTML = spinner;
                    });
                    this._processIcon = processSpan.outerHTML;
                    let completeSpan = document.createElement('span');
                    completeSpan.classList.add("wpt-font-icon_TickBold", SUCCESS_ICON_CLASS);
                    this._completeIcon = completeSpan.outerHTML;
                    let errorSpan = document.createElement('span');
                    errorSpan.classList.add("wpt-font-error", ERROR_ICON_CLASS);
                    this._errorIcon = errorSpan.outerHTML;
                    this._type.instanceReady(this.getHandle());
                };
                this._fileSelected = (event) => {
                    this._log.info("UploadFilesWidgetInstanceClass._fileSelected()");
                    if (!this._fileInput.files)
                        return;
                    for (let i = 0; i < this._fileInput.files.length; i++) {
                        this._storeFileReference(this._fileInput.files[i]);
                    }
                    this._refreshFileList();
                };
                // Returns true if stored, false if rejected
                this._storeFileReference = (file) => {
                    this._log.info("UploadFilesWidgetInstanceClass._storeFileReference()");
                    // Validate the file
                    if (!this._core.Helper.validateFileFormat(file.name.split('.').pop().toUpperCase())) {
                        this._core.Helper.presentWarningModal("STR_WPT_UPLOAD_INVALID_FORMAT");
                        return false;
                    }
                    if (!this._core.Helper.validateFileSize(file.size)) {
                        this._core.Helper.presentWarningModal("STR_WPT_UPLOAD_SIZE_EXCEEDED");
                        return false;
                    }
                    // We have a potentially valid file, but we want to minimise duplicates so scan the list for
                    // name and size already existing (have to hope path isn't important, we don't get it passed to us)
                    let inserted = false;
                    for (let fileTag in this._fileList) {
                        if ((this._fileList[fileTag].name == file.name) && (this._fileList[fileTag].size == file.size)) {
                            // Overwrite file entry
                            this._fileList[fileTag] = file;
                            inserted = true;
                            break;
                        }
                    }
                    // Store if we haven't already
                    if (!inserted)
                        this._fileList[`${this._counter++}`] = file;
                    return true;
                };
                this._fileDragEnter = (event) => {
                    this._log.info("UploadFilesWidgetInstanceClass._fileDragEnter()");
                    event.stopPropagation();
                    event.preventDefault();
                    if (this._draggedOver) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("already dragged over, ignore next leave...");
                        }
                        this._ignoreNextDragLeave = true;
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("starting drag over");
                        }
                        this._draggedOver = true;
                        this._ignoreNextDragLeave = false;
                        this._dropTarget.classList.add(DRAGOVER_CLASS);
                    }
                };
                this._fileDraggedOver = (event) => {
                    this._log.trace("UploadFilesWidgetInstanceClass._fileDraggedOver()");
                    event.stopPropagation();
                    event.preventDefault();
                };
                this._fileDragLeave = (event) => {
                    this._log.info("UploadFilesWidgetInstanceClass._fileDragLeave()");
                    event.stopPropagation();
                    event.preventDefault();
                    if (this._ignoreNextDragLeave) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("ignore this leave...");
                        }
                        this._ignoreNextDragLeave = false;
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("ending drag over");
                        }
                        this._draggedOver = false;
                        this._ignoreNextDragLeave = false;
                        this._dropTarget.classList.remove(DRAGOVER_CLASS);
                    }
                };
                this._fileDropped = (event) => {
                    this._log.info("UploadFilesWidgetInstanceClass._fileDropped()");
                    event.stopPropagation();
                    event.preventDefault();
                    this._draggedOver = false;
                    this._ignoreNextDragLeave = false;
                    this._dropTarget.classList.remove(DRAGOVER_CLASS);
                    // May get two different types of content here - pull into file list
                    let files = null;
                    if (event.dataTransfer && event.dataTransfer.files)
                        files = event.dataTransfer.files;
                    else if (event.target.files)
                        files = event.target.files;
                    if (!files)
                        return;
                    // Pull in files - this will naturally overwrite repeats if name and size match
                    // WARNING: This will prevent files of the same name from different directories being successfully uploaded
                    //          May need to think about this: it's either this behaviour or risk duplicates
                    for (let i = 0; i < files.length; i++) {
                        this._storeFileReference(files[i]);
                    }
                    this._refreshFileList();
                };
                this._browse = (event) => {
                    this._log.info("UploadFilesWidgetInstanceClass._browse()");
                    if (event)
                        event.preventDefault(); // prevent form submit
                    // Workaround for Chrome - if you select the same file twice it doesn't fire onchange, so clear value to force event firing
                    this._fileInput.value = null;
                    // Select a document or documents
                    this._fileInput.click();
                };
                this._refreshFileList = () => {
                    this._log.info("UploadFilesWidgetInstanceClass._refreshFileList()");
                    let fileCount = 0;
                    let rows = [];
                    if (this._currentTableData == null) {
                        let settings = {};
                        settings.Order = [[1, "asc"]];
                        settings.Paging = false;
                        let columns = [];
                        columns.push({ Title: "<span class='wpt-font-icon_Info'></span>", Orderable: false });
                        columns.push({ Title: this._core.Locale.getTranslation('STR_WPT_LABEL_FILE'), FilterType: "Text" });
                        columns.push({ Title: this._core.Locale.getTranslation('STR_WPT_LABEL_FILE_EXTENT'), FilterType: "Select" });
                        columns.push({ Title: this._core.Locale.getTranslation('STR_WPT_LABEL_SIZE'), FilterType: "Text" });
                        columns.push({ Title: this._core.Locale.getTranslation('STR_WPT_FILE_FORMAT'), FilterType: "Select" });
                        columns.push({ Title: "<span class='wpt-font-icon_Process'></span>", Orderable: false });
                        this._currentTableData = {
                            Columns: columns,
                            Rows: rows,
                            Settings: settings
                        };
                    }
                    else {
                        this._currentTableData.Rows = rows;
                    }
                    for (let fileTag in this._fileList) {
                        let metaValues = [];
                        let metadata = {
                            Name: FILETAG_ATTR,
                            Value: fileTag
                        };
                        metaValues.push(metadata);
                        let rowValues = [];
                        let rowData = {
                            Values: rowValues,
                            Metadata: metaValues,
                            CreatedCallback: this._rowCreated
                        };
                        let statusCellData = {
                            Value: "",
                            Display: "",
                            Sort: "",
                            Filter: ""
                        };
                        rowValues.push(statusCellData);
                        let nameCellData = {
                            Value: this._fileList[fileTag].name,
                            Display: this._fileList[fileTag].name,
                            Sort: this._fileList[fileTag].name,
                            Filter: this._fileList[fileTag].name
                        };
                        rowValues.push(nameCellData);
                        let extCellData = {
                            Value: this._fileList[fileTag].name.split('.').pop().toUpperCase(),
                            Display: this._fileList[fileTag].name.split('.').pop().toUpperCase(),
                            Sort: this._fileList[fileTag].name.split('.').pop().toUpperCase(),
                            Filter: this._fileList[fileTag].name.split('.').pop().toUpperCase()
                        };
                        rowValues.push(extCellData);
                        let sizeCellData = {
                            Value: this._fileList[fileTag].size.toString(10),
                            Display: this._fileList[fileTag].size.toString(10),
                            Sort: this._fileList[fileTag].size.toString(10),
                            Filter: this._fileList[fileTag].size.toString(10)
                        };
                        rowValues.push(sizeCellData);
                        let formatCellData = {
                            Value: this._fileList[fileTag].type,
                            Display: this._fileList[fileTag].type,
                            Sort: this._fileList[fileTag].type,
                            Filter: this._fileList[fileTag].type
                        };
                        rowValues.push(formatCellData);
                        let actionCellData = {
                            Value: ACTION_TEMPLATE,
                            Display: ACTION_TEMPLATE,
                            Sort: ACTION_TEMPLATE,
                            Filter: ACTION_TEMPLATE,
                            PreventSanitising: true
                        };
                        rowValues.push(actionCellData);
                        rows.push(rowData);
                        fileCount++;
                    }
                    if (fileCount) {
                        this._displayTableData();
                        this._core.Functions.showElement(this._filesTableHolder);
                        this._core.Functions.showElement(this._uploadButtonDiv);
                    }
                    else {
                        this._dataTable.displayData({ Columns: [], Rows: [] });
                        this._core.Functions.hideElement(this._filesTableHolder);
                        this._core.Functions.hideElement(this._uploadButtonDiv);
                    }
                };
                this._rowCreated = (row) => {
                    this._log.info("UploadFilesWidgetInstanceClass._rowCreated()");
                    let uploadSpan = row.querySelector('.' + UPLOAD_ICON_CLASS);
                    if (uploadSpan)
                        uploadSpan.addEventListener('click', this._uploadClicked);
                    let removeSpan = row.querySelector('.' + REMOVE_ICON_CLASS);
                    if (removeSpan)
                        removeSpan.addEventListener('click', this._removeClicked);
                };
                this._removeClicked = (event) => {
                    this._log.info("UploadFilesWidgetInstanceClass._removeClicked()");
                    if (event)
                        event.stopPropagation();
                    let clickedItem = event.currentTarget;
                    let fileTag = clickedItem.parentElement.parentElement.parentElement.getAttribute(FILETAG_ATTR);
                    this._removeRow(fileTag);
                };
                this._removeRow = (fileTag, refreshTable = true) => {
                    this._log.info("UploadFilesWidgetInstanceClass._removeRow()");
                    let index = this._currentTableData.Rows.findIndex(row => row.Metadata.find(meta => meta.Name == FILETAG_ATTR).Value == fileTag);
                    if (index > -1) {
                        this._currentTableData.Rows.splice(index, 1);
                    }
                    if (fileTag in this._fileList)
                        delete this._fileList[fileTag];
                    if (refreshTable) {
                        this._displayTableData();
                    }
                };
                this._displayTableData = () => {
                    this._log.info("UploadFilesWidgetInstanceClass._displayTableData()");
                    this._dataTable.displayData(this._currentTableData);
                };
                this._uploadClicked = (event) => {
                    this._log.info("UploadFilesWidgetInstanceClass._uploadClicked()");
                    if (event)
                        event.stopPropagation();
                    let clickedItem = event.currentTarget;
                    this._activeFileTag = clickedItem.parentElement.parentElement.parentElement.getAttribute(FILETAG_ATTR);
                    this._clearAndRequestUploadInfo();
                };
                this._uploadFile = (fileTag) => {
                    this._activeFileTag = null;
                    let file = this._fileList[fileTag];
                    let requestUpload = {
                        DocType: this._uploadDocType.Name,
                        FileType: file.name.split('.').pop().toUpperCase(),
                        KeywordRecords: this._uploadKeys,
                        PreventAddToWorkflow: false
                    };
                    if (this._uploadDocDate)
                        requestUpload.Date = this._uploadDocDate;
                    else
                        requestUpload.Date = this._core.Functions.dateNumberToTransportFormat(Date.now());
                    let request = JSON.stringify(requestUpload);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Request: ${request}`);
                    }
                    let formData = new FormData();
                    formData.append("request", request);
                    formData.append('file', file);
                    let headers = {
                        "Content-Type": "multipart/form-data"
                    };
                    // Before we fire, update the UI
                    this._removeActionIcons(fileTag, false);
                    this._setProcessingIcon(fileTag);
                    this._core.Loader.genericServiceCallWithData('/Upload.svc/rest/MultiPartUploadDocument', formData, this._finishedUpload.bind(this, fileTag), headers, this._errorUpload.bind(this, fileTag), this._failedUpload.bind(this, fileTag));
                };
                this._removeActionIcons = (fileTag, refreshTable = true) => {
                    this._log.info("UploadFilesWidgetInstanceClass._removeActionIcons()");
                    let row = this._currentTableData.Rows.find(row => row.Metadata.find(meta => meta.Name == FILETAG_ATTR).Value == fileTag);
                    if (row) {
                        row.Values[5] = {
                            Display: "",
                            Filter: "",
                            Sort: "",
                            Value: ""
                        };
                        if (refreshTable) {
                            this._displayTableData();
                        }
                    }
                };
                this._addRemoveActionIcon = (fileTag, refreshTable = true) => {
                    this._log.info("UploadFilesWidgetInstanceClass._addRemoveActionIcon()");
                    let row = this._currentTableData.Rows.find(row => row.Metadata.find(meta => meta.Name == FILETAG_ATTR).Value == fileTag);
                    if (row) {
                        row.Values[5] = {
                            Display: REMOVE_TEMPLATE,
                            Filter: REMOVE_TEMPLATE,
                            Sort: REMOVE_TEMPLATE,
                            Value: REMOVE_TEMPLATE,
                            PreventSanitising: true
                        };
                        if (refreshTable) {
                            this._displayTableData();
                        }
                    }
                };
                this._addActionIcons = (fileTag, refreshTable = true) => {
                    this._log.info("UploadFilesWidgetInstanceClass._addActionIcons()");
                    let row = this._currentTableData.Rows.find(row => row.Metadata.find(meta => meta.Name == FILETAG_ATTR).Value == fileTag);
                    if (row) {
                        row.Values[5] = {
                            Display: ACTION_TEMPLATE,
                            Filter: ACTION_TEMPLATE,
                            Sort: ACTION_TEMPLATE,
                            Value: ACTION_TEMPLATE,
                            PreventSanitising: true
                        };
                        if (refreshTable) {
                            this._displayTableData();
                        }
                    }
                };
                this._setProcessingIcon = (fileTag, refreshTable = true) => {
                    this._log.info("UploadFilesWidgetInstanceClass._setProcessingIcon()");
                    let row = this._currentTableData.Rows.find(row => row.Metadata.find(meta => meta.Name == FILETAG_ATTR).Value == fileTag);
                    if (row) {
                        row.Values[0] = {
                            Display: this._processIcon,
                            Filter: this._processIcon,
                            Sort: this._processIcon,
                            Value: this._processIcon,
                            PreventSanitising: true
                        };
                        if (refreshTable) {
                            this._displayTableData();
                        }
                    }
                };
                this._setCompleteIcon = (fileTag, refreshTable = true) => {
                    this._log.info("UploadFilesWidgetInstanceClass._setCompleteIcon()");
                    let row = this._currentTableData.Rows.find(row => row.Metadata.find(meta => meta.Name == FILETAG_ATTR).Value == fileTag);
                    if (row) {
                        row.Values[0] = {
                            Display: this._completeIcon,
                            Filter: this._completeIcon,
                            Sort: this._completeIcon,
                            Value: this._completeIcon,
                            PreventSanitising: true
                        };
                        if (refreshTable) {
                            this._displayTableData();
                        }
                    }
                };
                this._setErrorIcon = (fileTag, refreshTable = true) => {
                    this._log.info("UploadFilesWidgetInstanceClass._setErrorIcon()");
                    let row = this._currentTableData.Rows.find(row => row.Metadata.find(meta => meta.Name == FILETAG_ATTR).Value == fileTag);
                    if (row) {
                        row.Values[0] = {
                            Display: this._errorIcon,
                            Filter: this._errorIcon,
                            Sort: this._errorIcon,
                            Value: this._errorIcon,
                            PreventSanitising: true
                        };
                        if (refreshTable) {
                            this._displayTableData();
                        }
                    }
                };
                this._uploadAllClicked = (event) => {
                    this._log.info("UploadFilesWidgetInstanceClass._uploadAllClicked()");
                    this._activeFileTag = "[[ALL]]";
                    this._clearAndRequestUploadInfo();
                };
                this._uploadAllFiles = () => {
                    // To maintain UI intergrity, we're actually going to call the click event for all the visible upload buttons
                    this._activeFileTag = null;
                    for (let fileTag in this._fileList) {
                        this._uploadFile(fileTag);
                    }
                };
                this._finishedUpload = (fileTag, docData) => {
                    this._log.info("UploadFilesWidgetInstanceClass._finishedUpload()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`with tag ${fileTag}`);
                    }
                    // Tidy UI
                    if (this._clearRowOnUpload) {
                        this._removeRow(fileTag);
                    }
                    else {
                        this._setCompleteIcon(fileTag, false);
                        this._addRemoveActionIcon(fileTag);
                    }
                    // Tidy file List (file entry may already be gone if uploaded)
                    if (fileTag in this._fileList)
                        delete this._fileList[fileTag];
                    // Tell everyone we've uploaded something
                    if (docData.MultiPartUploadDocumentResult.Documents && (docData.MultiPartUploadDocumentResult.Documents.length > 0)) {
                        let doc = docData.MultiPartUploadDocumentResult.Documents[0];
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_UPLOADED);
                        navEvent.ActivationID = doc.ItemNum;
                        navEvent.PrimaryContext = doc;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._errorUpload = (fileTag, url, status, text) => {
                    this._log.info("UploadFilesWidgetInstanceClass._errorUpload()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`with tag ${fileTag}`);
                    }
                    this._handleError(fileTag);
                };
                this._handleError = (fileTag) => {
                    this._log.info("UploadFilesWidgetInstanceClass._handleError()");
                    let fileName = null;
                    this._setErrorIcon(fileTag);
                    if (this._preventRetryUpload) {
                        if (fileTag in this._fileList) {
                            fileName = this._fileList[fileTag].name;
                            delete this._fileList[fileTag];
                        }
                        this._addRemoveActionIcon(fileTag);
                    }
                    else
                        this._addActionIcons(fileTag);
                    let msg = this._core.Locale.getTranslation('STR_WPT_UPLOAD_ERROR_ENCOUNTERED');
                    if (fileName) {
                        this._core.Helper.presentWarningModal(`${msg}: ${fileName}`);
                    }
                    else {
                        this._core.Helper.presentWarningModal(msg);
                    }
                };
                this._failedUpload = (fileTag, docData) => {
                    this._log.info("UploadFilesWidgetInstanceClass._failedUpload()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`with tag ${fileTag}`);
                    }
                    this._handleError(fileTag);
                };
                this._failedUploadDataRetrieval = (failMessage) => {
                    if (this._awaitingUploadData) {
                        this._awaitingUploadData = false;
                        this._uploadDocType = null;
                        this._uploadKeys = null;
                        this._uploadDocDate = null;
                        this._activeFileTag = null;
                        this._core.Helper.presentWarningModal(failMessage);
                    }
                };
                this._clearAndRequestUploadInfo = () => {
                    this._awaitingUploadData = true;
                    this._uploadDocType = null;
                    this._uploadKeys = null;
                    this._uploadDocDate = null;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.REQUEST_DOC_UPLOAD_INFO);
                    navEvent.ActivationID = 0;
                    navEvent.Layout = this._currentLayout;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    // Get ready to choke if we get stuck
                    this._awaitTimerId = window.setTimeout(this._failedUploadDataRetrieval.bind(this, 'STR_WPT_NO_DOWNLOAD_INFO'), 3000);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("UploadFilesWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._acceptFilter = this._core.Config.getApplicationConfig().DefaultAcceptFilter;
            }
            activate(context) {
                this._log.info("UploadFilesWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.RESPONSE_UPLOAD_DOCTYPE:
                        if (this._awaitingUploadData) {
                            if (context.hasOwnProperty('PrimaryContext') && (context.PrimaryContext))
                                this._uploadDocType = context.PrimaryContext;
                            else
                                this._uploadDocType = this._core.OBHelper.DocumentTypesById[context.ActivationID];
                            if (this._uploadKeys != null) {
                                window.clearTimeout(this._awaitTimerId);
                                this._awaitingUploadData = false;
                                if (this._activeFileTag == "[[ALL]]")
                                    this._uploadAllFiles();
                                else
                                    this._uploadFile(this._activeFileTag);
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.RESPONSE_UPLOAD_KEYWORDS:
                        if (this._awaitingUploadData) {
                            if (context.PrimaryContext) {
                                window.clearTimeout(this._awaitTimerId);
                                this._uploadKeys = context.PrimaryContext;
                                if (">>DocumentDate" in context.AdditionalContext)
                                    this._uploadDocDate = context.AdditionalContext[">>DocumentDate"];
                                if (this._uploadDocType != null) {
                                    this._awaitingUploadData = false;
                                    if (this._activeFileTag == "[[ALL]]")
                                        this._uploadAllFiles();
                                    else
                                        this._uploadFile(this._activeFileTag);
                                }
                            }
                            else {
                                window.clearTimeout(this._awaitTimerId);
                                this._failedUploadDataRetrieval('STR_WPT_REQUIRED_ARCHIVE_KEYS_MISSING');
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCTYPE_DESELECTED:
                        this._uploadDocType = null;
                        break;
                }
            }
        }
        UploadFilesWidgetInstanceClass.HtmlData = null;
        Widgets.UploadFilesWidgetInstanceClass = UploadFilesWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
